<template>
  <div class="shop_introduction">
   	<topbar></topbar>
		<div class="clear"></div>
		<!--店铺banner 开始-->
		<div class="hq-shop-banner">
			<a :href="bannerItem.link" >
				<img v-bind:src="bannerItem.mediaCode" width="1400" height="120">
			</a>
		</div>
		<!--店铺banner 结束-->
		<!--店铺导航 开始-->
		<div class="hq-shop-header">
			<div class="w1200 bc bd">
				<ul class="hq-shop-nav">
					<li>
						<a href="#">首页</a>
					</li>
					
<!--					<li class="all-goods pr" v-on:mouseenter="goodsCateShow()" v-on:mouseleave="goodsCateHidden()">
						<router-link :to="{path:'/shop_goods_list'}">全部商品<i class="dp-ico-a-1"></i></router-link>
						<ol class="categorys-dropdown none">
							<li v-for="catBo in shopCatList">
								<router-link :to="{path:'/shop_goods_list',query:{catCode:catBo.catCode,shopCode:shopCode}}">{{catBo.catNameCn}}</router-link>
							</li>
						</ol>
					</li>-->
					<li>
						<a>企业介绍</a>
					</li>
				</ul>
				<div class="hq-shop-zx fr">
					<a class="a-btn-zx" href="javascript:void(0);" v-on:mouseenter="shopAskAndFavoriteShow()" >咨询／收藏<i class="dp-ico-a-1"></i></a>
					<div class="zx-drop-box none" v-on:mouseleave="shopAskAndFavoriteHidden()">
						<div class="item-1">
							<i class="dp-ico-arrw"></i>
							<p>店铺等级：<span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span><span class="dp-ico-dpdj"></span></p>
							<p>信用等级： v6 <span class="dp-ico-xydj"></span></p>
						</div>
						<div class="item-2">
							<a class="a-btn-zxzx" href="#"><i class="dp-ico-zxzx"></i>在线咨询</a>
							<a class="a-btn-scbd ml10" v-on:click="addOrDeleteFavoriteShop()"><i class="dp-ico-scbd"></i>{{ isExistFavoriteShop==0? '收藏本店' : '已经收藏' }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--店铺导航 结束-->
		
<div class="w1200 bc">
	 <!--企业介绍 开始-->
   <div class="shop-tabbox-1 shop-jp-tj">
      <div class="hd hd-2">
          <ul>
              <li class="hover mb20"><a href="javascript:void(0);">企业介绍</a></li>
          </ul>
      </div>
      <div class="bd bd-2">
      	 <div class="shop-qyjs-box">
         	<dl>
            	<dt>店铺信息</dt>
                <dd>所在地区： {{shopBo.province}}{{shopBo.city}}{{shopBo.district}}</dd>
                <dd>工商执照：<img class="v_mid" src="../../../static/images/ico-gs.jpg" width="18" height="20"></dd>
            </dl>
           <dl>
            	<dt>联系我们</dt>
                <dd>联系客服：<a class="a-btn-zxzx" :href="shopBo.qq"><i class="dp-ico-zxzx"></i>在线咨询</a></dd>
                <dd>收藏店铺：<a class="a-btn-scbd" href="javascript:void(0);" v-on:click="addOrDeleteFavoriteShop()"><i class="dp-ico-scbd"></i>{{ isExistFavoriteShop==0? '收藏本店' : '已经收藏' }}</a></dd>
            </dl>
            <dl>
            	<dt>店铺服务</dt>
                <dd>
                	<img class="mr8" src="../../../static/images/ico-fwbz-1.png" width="68" height="68">
                    <img class="mr8" src="../../../static/images/ico-fwbz-2.png" width="68" height="68">
                    <img class="mr8" src="../../../static/images/ico-fwbz-3.png" width="68" height="68">
                </dd>
            </dl>
         </div>
         <div class="content">
	         	<div class="shopDesc"  v-html = "shopBo.shopDesc">
	         		{{ shopBo.shopDesc }}
	         	</div>
         </div>
     </div>
  </div>
  <!--企业介绍 结束-->
	
</div>
<!--container 结束-->

		<footermenu></footermenu>
		<footercopyright></footercopyright>

    </div>
</template>

<script>
/*引入Vue框架*/
import Vue from 'vue'
/*引入资源请求插件*/
import VueResource from 'vue-resource'
/*使用VueResource插件*/
Vue.use(VueResource)
import TopBar from '@/components/TopBar'
import EmallHeader from '@/components/EmallHeader'
import FooterMenu from '@/components/FooterMenu'
import FooterCopyright from '@/components/FooterCopyright'
//import jQuery from "../../../static/js/jquery.min.js"
import jQuery from 'jquery';
import {getImgUrl,getAjaxUrl} from "../../../static/js/emallUtils.js"
import alertConfirm from "../../../static/js/alertConfirm.js"
import { Swipe, SwipeItem } from 'mint-ui';
import API from "../../../static/api/api.js"
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
export default {
  name: 'shop_introduction',
  data () {
    return {
       shopBo:{},
       sliderItems:[],
       bannerItem:{},
       adsItem:{},
       bottomAdsItem:{},
       sliderHeight: '370px',
       shopCatList:'',
       shopCode:'',
       catCode:'categoryAll',
     	 interval:'intervalAll',
     	 sortTime:'timeAll',
     	 currentPage:1,
     	 totalPage:1,
     	 orderBy:'',
     	 orderAsc:'',
     	 isExistFavoriteShop:0
    }
  },
  components:{
				'topbar':TopBar,
				'emallheader':EmallHeader,
				'footermenu':FooterMenu,
				'footercopyright':FooterCopyright
  },
  methods:{
	  goodsCateShow:function(){
				$(".categorys-dropdown").show();
		},
		goodsCateHidden:function(){
				$(".categorys-dropdown").hide();
		},
	  shopAskAndFavoriteShow:function(){
				$(".zx-drop-box").show();
		},
		shopAskAndFavoriteHidden:function(){
				$(".zx-drop-box").hide();
		},		
  	getShopInfo:function(){
  			var that = this;
  			var shopCode = that.shopCode;
  			this.$http.jsonp(getAjaxUrl()+"/shop/ajax_shop.json",
		      {
		        params: {
		            shopCode:shopCode
		        },
					  jsonp:'callback'
		      }).then(function(res){
		         if(res.body.code == "success"){
		         		
		         		 var adsList = res.body.data.adsList;
		         		 var shopBo = res.body.data.shopBo;
		         		 if(shopBo != undefined){
		         		 		 var qq = shopBo.qq;
		         		 		 if(qq != undefined && qq != ''){
		         		 		 		shopBo.qq = 'http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=' + qq;
		         		 		 }
		         		 		 var shopDesc = shopBo.shopDesc;
		         		 		 if(shopDesc != undefined && shopDesc != ''){
		         		 		 		shopBo.shopDesc = shopDesc.replace(/\/upload\//g, getImgUrl()+"/upload/");
		         		 		 }
		         		 		 that.shopBo = shopBo;
		         		 }
		         		 if(adsList != undefined){
		         		 		var sliderItems = new Array();
		         		 		for(var i=0;i<adsList.length;i++){
		         		 			 adsList[i].mediaCode = getImgUrl() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
		         		 			 if(adsList[i].adsType == "slider"){
		         		 			 		sliderItems.push(adsList[i]);
		         		 			 }else if(adsList[i].adsType == "banner"){
		         		 			 	  that.bannerItem = adsList[i];
		         		 			 }else if(adsList[i].adsType == "inner_ads"){
		         		 			 	  that.adsItem = adsList[i];
		         		 			 }else if(adsList[i].adsType == "bottom_slogen"){
		         		 			 	  that.bottomAdsItem = adsList[i];
		         		 			 }
		         		 		}
		         		 		that.sliderItems = sliderItems;
		         		 }
		         }
		      },function(){
		        
		      });
  	},
  		
  			getShopCat:function(){
  						var that = this;
  						var shopCode = that.shopCode;
  						var isShow = "y";
  						var isLeaf = "y";
				      this.$http.jsonp(getAjaxUrl()+"/shop/ajax_shop_cat.json",
				      {
				        params: {
				            shopCode:shopCode,
				            isShow:isShow,
				            isLeaf:isLeaf
				        },
        					jsonp:'callback'
				      }).then(function(res){
				         if(res.body.code == "success"){
				         	   var shopCatList = res.body.data.shopCatList;
				         	   that.shopCatList = shopCatList;
				         }else{
				         	
				         }
				      },function(){
				        
				      });
					
  			},
				addOrDeleteFavoriteShop:function() {
					var that = this;
					var shopCode = that.shopCode;
					if(0==that.isExistFavoriteShop){
						API.addUserFavorite("shop",null,shopCode,function(ret){
							if(ret.code != null && ret.code == "success") {
								that.isExistFavoriteShop = 1;
							}else{
								alertConfirm.singleConfirm(ret.msg);
							}
						});
					}else if(1==that.isExistFavoriteShop){
						API.deleteFavoriteBycode("shop",null,shopCode,function(ret){
							if(ret.code != null && ret.code == "success") {
								that.isExistFavoriteShop = 0;
							}else{
								alertConfirm.singleConfirm(ret.msg);
							}
						});						
					}
				},
				existFavoriteShop:function() {
					var that = this;
					var shopCode = that.shopCode;
					API.isExistFavorite("shop",null,shopCode,function(ret){
						if(ret.code != null && ret.code == "success") {
							that.isExistFavoriteShop = ret.data.isExist;
						}else{
							console.error("existFavorite请求失败："+ret.msg);
						}
					});
				} 			
  },
	 	beforeMount:function(){
    	var shopCode =  this.$route.query.shopCode;
    	if(shopCode != undefined){
				this.shopCode = shopCode;
			}	 		
			this.existFavoriteShop();  	
	  },  
    mounted(){
    	window.scrollTo(0, 0);
    	var shopCode =  this.$route.query.shopCode;
    	if(shopCode != undefined){
				this.shopCode = shopCode;
			}
			this.getShopInfo();
			this.getShopCat();
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
	.shopDesc img{
		    width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/page/shop/shop_introduction.vue